import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  isCommonLoading: false,
  navigation: false,
  startProjectPop: false,
  recruitPop: false,
  pdsPop: false,
  culturePop: false,
  awardsPop: false,
  privacyPolicyPop: false,
  introVal: null,
  weather: '',
  adress: '',
  readyAction: false,
  lnbCopy: 'Hi~ We are PULIP :P',
  pdsLnb: false,
  prevTit: null,
  loading: false
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
